import { render, staticRenderFns } from "./IconLineage.vue?vue&type=template&id=56c5347b"
import script from "./IconLineage.vue?vue&type=script&lang=js"
export * from "./IconLineage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports